import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bca166c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weeek-statuses__block" }

import { WeeekDataModel } from "@/models";
import { PropType } from "vue";
import WeeekTagsItem from "./weeek-tags-item.vue";
import { TagModel } from "@/components/task-forms/models";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'weeek-tags',
  props: {
  /**Данные weeek */
  dataWeeek: { type: Object as PropType<WeeekDataModel> },
  /**Теги проекта ПМ */
  tagsProjectPm: { type: Array as PropType<TagModel[]> },
},
  emits: ["searchTags"],
  setup(__props, { emit }) {

const props = __props;


/**События */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataWeeek.TagsWeeek, (tagDataWeeek, index) => {
      return (_openBlock(), _createBlock(WeeekTagsItem, {
        key: tagDataWeeek.TagId,
        index: index,
        tagsDataWeeek: __props.dataWeeek.TagsWeeek,
        tagDataWeeek: tagDataWeeek,
        tagsProjectPm: __props.tagsProjectPm,
        onSearchTags: _cache[0] || (_cache[0] = ($event: any) => (emit('searchTags', $event)))
      }, null, 8, ["index", "tagsDataWeeek", "tagDataWeeek", "tagsProjectPm"]))
    }), 128))
  ]))
}
}

})